
export class FeatureCollection{
  type: string;
  features: Array<Features>;

}

 export class Features{
  type : string;
  id: string;
  geometry: Geometry;
  properties : any;
}
export class Geometry {
  type : string;
  coordinates : Array<any>;
}
